import React, { useState } from "react";
import Footer from "../../components/general/footer.jsx";
import Candidature from "../../components/main/candidate";
import "../../assets/css/candidature.css";
import NavBar from "../../components/general/navBar.jsx";

const Candidate = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="main">
            <NavBar />
            <Candidature />
            <Footer />
        </div>
    );
}

export default Candidate;